var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('top-menu',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path !='/login' ? true : false && _vm.$route.path !='/home' ? true : false),expression:"$route.path !='/login' ? true : false && $route.path !='/home' ? true : false"}]}),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('notifications',{attrs:{"group":"foo","position":"top right","animation-type":"velocity"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ac06dde","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 316
// module chunks = 0